import styled from 'styled-components';

import { breakpoints } from '../constants';

const fontSizes = {
  primary: {
    large: '75px',
    medium: '55px',
    small: '40px',
  },
  secondary: {
    large: '45px',
    medium: '35px',
    small: '30px',
  },
};

const lineHeights = {
  primary: {
    large: '80px',
    medium: '60px',
    small: '45px',
  },
  secondary: {
    large: '50px',
    medium: '40px',
    small: '35px',
  },
};

interface HeadingProps {
  type: 'primary' | 'secondary';
  flush?: boolean;
}

const H2 = styled.h2<HeadingProps>`
  line-height: ${(props) => lineHeights[props.type].small};
  font-size: ${(props) => fontSizes[props.type].small};
  width: 100%;
  margin-bottom: ${(props) => (props.flush ? '0.2em' : '0.6em')};

  @media (min-width: ${breakpoints.tablet}) {
    font-size: ${(props) => fontSizes[props.type].medium};
    line-height: ${(props) => lineHeights[props.type].medium};
    letter-spacing: ${(props) => (props.type === 'primary' ? '-1.5px' : null)};
  }

  @media (min-width: ${breakpoints.desktop}) {
    font-size: ${(props) => fontSizes[props.type].large};
    line-height: ${(props) => lineHeights[props.type].large};
    letter-spacing: ${(props) => (props.type === 'primary' ? '-2px' : null)};
  }
`;

export default H2;
